module.exports = __webpack_public_path__ + "static/media/cv.a4107cc4.webp";